import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ce-parameter-list',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ce-parameter-list.component.html',
    styleUrl: './ce-parameter-list.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'CeParameterList',
        '[class.CeParameterList--noSeparator]': 'noSeparator',
        '[class.CeParameterList--small]': 'size === "small"',
    },
})
export class CeParameterListComponent {
    @Input() noSeparator = false;
    @Input() size: 'small' | 'default' = 'default';
}
